module.exports = {
	"plantlod": {
		"name": "Level of detail",
		"type": "lod",
		"defaultIndex": 0
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/data/asset/settings/3dplant.json
// module id = 2485
// module chunks = 0